export default __webpack_public_path__ + "static/media/audit.b87058b1.svg";